import React from 'react';
import { motion } from 'framer-motion';
import { Star, Instagram, Facebook } from 'lucide-react';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-347">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-348" />
  </svg>;
interface TestimonialCardProps {
  name: string;
  text: string;
}
function TestimonialCard({
  name,
  text
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="bg-deepblack border border-gold/30 rounded-lg p-6 shadow-lg" data-id="element-349">
      <div className="flex gap-1 mb-4" data-id="element-350">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-351" />)}
      </div>
      <p className="text-bone mb-4 leading-relaxed" data-id="element-352">{text}</p>
      <p className="text-gold font-semibold" data-id="element-353">— {name}</p>
    </motion.div>;
}
export function Testimonios() {
  const testimonials = [{
    name: 'Carlos M.',
    text: 'La mejor barbería del sur de Bogotá. Santiago tiene una mano increíble para el degradado. Ya no voy a otro lado.'
  }, {
    name: 'Andrés R.',
    text: 'La membresía Gold es una locura de precio. 3 cortes y 3 perfilados de barba por 42 mil. Imposible encontrar algo mejor en Perdomo.'
  }, {
    name: 'Jennifer L.',
    text: 'Llevo a mi esposo y a mi hijo cada mes. La membresía Padre e Hijo es perfecta. Paola es muy amable y profesional.'
  }];
  return <section className="py-20 bg-testimonialgray" data-id="element-354">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-355">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-356">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-bone mb-4" data-id="element-357">
            Lo que Dicen Nuestros Clientes
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-358">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} data-id="element-359" />)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-360">
          <p className="text-bone mb-6 text-lg" data-id="element-361">
            ¿Ya nos visitaste? ¡Déjanos tu reseña!
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-362">
            <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gold hover:text-white transition-colors" data-id="element-363">
              <Instagram className="w-6 h-6" data-id="element-364" />
            </a>
            <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gold hover:text-white transition-colors" data-id="element-365">
              <Facebook className="w-6 h-6" data-id="element-366" />
            </a>
            <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gold hover:text-white transition-colors" data-id="element-367">
              <WhatsAppIcon data-id="element-368" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}